import { PAPER_SIZES } from "../lib/couriers";
import { Barcode } from "./Barcode";
import { QrCode } from "./QrCode";
import { AlertTriangle, Phone, Store } from "lucide-react";

const PX = 3.7795; // px per mm at 96dpi

export function ThermalLabel({ data, controls, store, isPro, forwardRef, idx }) {
  const { w, h } = PAPER_SIZES[controls.paperSize];
  const compact = h <= 50;
  const mini = h <= 30;
  const code = data.code || data.phone || "RESICETAK";

  const base = {
    width: `${w}mm`,
    height: `${h}mm`,
    padding: mini ? "2mm" : compact ? "2.5mm" : "4mm",
    boxSizing: "border-box",
  };

  return (
    <div
      ref={forwardRef}
      data-testid={`thermal-label${idx !== undefined ? "-" + idx : ""}`}
      className="thermal-label bg-white text-black flex flex-col overflow-hidden"
      style={{ ...base, fontFamily: "'JetBrains Mono', monospace", lineHeight: 1.25 }}
    >
      {/* Header: store + courier */}
      <div className="flex items-start justify-between border-b-2 border-black pb-1">
        <div className="flex items-center gap-1 min-w-0">
          {controls.showLogo && isPro && store.logo ? (
            <img src={store.logo} alt="logo" style={{ height: mini ? 16 : 22 }} className="object-contain" />
          ) : controls.showLogo ? (
            <Store size={mini ? 12 : 16} strokeWidth={2.5} />
          ) : null}
          <span className="font-extrabold uppercase truncate" style={{ fontSize: mini ? 8 : compact ? 9 : 11 }}>
            {store.storeName || "TOKO SAYA"}
          </span>
        </div>
        {data.courier ? (
          <span className="font-black uppercase border-2 border-black px-1 whitespace-nowrap"
            style={{ fontSize: mini ? 7 : compact ? 8 : 10 }}>
            {data.courier}
          </span>
        ) : null}
      </div>

      {/* Sender */}
      {controls.showSender && !mini && (store.senderName || store.senderAddress) && (
        <div className="border-b border-dashed border-black py-1" style={{ fontSize: compact ? 7 : 8 }}>
          <span className="font-bold">DARI: </span>
          <span>{store.senderName}{store.senderPhone ? ` • ${store.senderPhone}` : ""}</span>
          {!compact && store.senderAddress && <div className="leading-tight">{store.senderAddress}</div>}
        </div>
      )}

      {/* Recipient */}
      <div className="flex-1 py-1 overflow-hidden">
        <div className="font-bold uppercase" style={{ fontSize: mini ? 6 : 8 }}>KEPADA:</div>
        <div className="font-extrabold uppercase" style={{ fontSize: mini ? 9 : compact ? 11 : 14 }}>
          {data.recipient_name || "Nama Penerima"}
        </div>
        {data.phone && (
          <div className="flex items-center gap-1 font-bold" style={{ fontSize: mini ? 8 : compact ? 9 : 11 }}>
            <Phone size={mini ? 8 : 11} strokeWidth={2.5} /> {data.phone}
          </div>
        )}
        <div style={{ fontSize: mini ? 7 : compact ? 8 : 10.5 }} className="leading-snug mt-0.5">
          {data.address || "Alamat lengkap penerima akan muncul di sini"}
        </div>
      </div>

      {/* Items / COD */}
      {!mini && controls.showItems && data.items && (
        <div className="border-t border-dashed border-black pt-0.5" style={{ fontSize: compact ? 7 : 9 }}>
          <span className="font-bold">ISI: </span>{data.items}
        </div>
      )}
      {!mini && controls.showCod && data.cod && (
        <div className="font-black border border-black px-1 mt-0.5 inline-block" style={{ fontSize: compact ? 8 : 10 }}>
          COD: Rp {Number(data.cod).toLocaleString("id-ID")}
        </div>
      )}

      {/* Codes */}
      {(controls.showBarcode || controls.showQR) && (
        <div className="flex items-end justify-between gap-2 border-t-2 border-black pt-1 mt-1">
          {controls.showBarcode && (
            <div className="flex-1 min-w-0">
              <Barcode value={code} height={mini ? 22 : compact ? 28 : 38} />
            </div>
          )}
          {controls.showQR && <QrCode value={code} size={mini ? 36 : compact ? 46 : 66} />}
        </div>
      )}

      {/* Fragile */}
      {controls.showFragile && !mini && (
        <div className="flex items-center justify-center gap-1 border-2 border-black font-black uppercase mt-1 py-0.5"
          style={{ fontSize: compact ? 8 : 10 }}>
          <AlertTriangle size={compact ? 12 : 15} strokeWidth={2.5} /> Barang Pecah Belah / Fragile
        </div>
      )}

      {/* Watermark for free tier */}
      {!isPro && !mini && (
        <div className="text-center font-mono mt-0.5" style={{ fontSize: 6.5, opacity: 0.6 }}>
          dibuat gratis dengan ResiCetak.work
        </div>
      )}
    </div>
  );
}

export { PX };
